import React, { useEffect } from 'react';

export default function Teste(): JSX.Element {
  useEffect(() => {
    window.location.href = 'nutridevproject://convite/158189';
  }, []);

  return <div>TESTE</div>;
}
